export default __webpack_public_path__ + "static/media/Docx.fa82f9de.svg";